/**
 * Global Announcement Bar
 */
function announcementBar() {
  const config = {
    id: 'headerPromo',
    pause: 'announcementPause',
    focusableEls: 'a, button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])',
  };

  // cached dom elements
  const $headerPromo = document.getElementById(config.id);

  function init() {
    if ($headerPromo) initHeaderPromo();
  }

  function initHeaderPromo() {
    const flickityOpts = {
      autoPlay: 5000,
      prevNextButtons: true,
      setGallerySize: true,
      adaptiveHeight: false,
      wrapAround: true,
      dragThreshold: 15,
      pauseAutoPlayOnHover: false,
      pageDots: false,
    };

    const flickityPause = document.getElementById(config.pause);
    flickityPause.addEventListener('click', () => {
      flickity.pausePlayer();
    });

    const flickity = new Flickity($headerPromo, flickityOpts);
    $headerPromo.removeAttribute('tabindex');

    flickity.on('select', function() {
      this.cells.forEach((cell) => {
        cell.element.setAttribute('aria-hidden', 'true');
        const focusableElements = cell.element.querySelectorAll(config.focusableEls);
        focusableElements.forEach((el) => {
          el.setAttribute('tabindex', '-1');
        });
      });

      this.selectedElement.setAttribute('aria-hidden', 'false');
      const focusableInSelected = this.selectedElement.querySelectorAll(config.focusableEls);
      focusableInSelected.forEach((el) => {
        el.setAttribute('tabindex', '0');
      });
    });

  }

  return init();
}

announcementBar();
